import { FC } from 'react';
import { createPortal } from 'react-dom';
import { ModalContent, ModalProps } from './ModalContent';

export const Modal: FC<ModalProps> = ({ children, onClose, ...props }) => {
  const content = (
    <ModalContent onClose={onClose} {...props}>
      {children}
    </ModalContent>
  );

  return createPortal(content, document.body);
};
